import { connect } from "react-redux";
import { connect as formikConnect } from "formik";
import { ownerCompany } from "selectors/company";

import Channel from "./Channel";

const mapStateToProps = (
  state,
  {
    formik: {
      values: { company = {} },
    },
  }
) => ({
  currentUserCompanyID: state.currentUser.company.id,
  ownerCompanyID: (ownerCompany(state) || company).id,
});

export default formikConnect(connect(mapStateToProps)(Channel));
